export default function ProjectWriteIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        stroke="currentColor"
        d="M13.333 3.336c1.813.01 2.794.09 3.435.73.732.733.732 1.911.732 4.268v5c0 2.357 0 3.536-.732 4.268-.733.732-1.911.732-4.268.732h-5c-2.357 0-3.536 0-4.268-.732-.732-.732-.732-1.91-.732-4.268v-5c0-2.357 0-3.535.732-4.267.64-.64 1.622-.721 3.435-.731"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="M6.664 11.664h6.667M5.836 8.75h8.333M7.5 14.586h5"
      />
      <path
        stroke="currentColor"
        d="M6.664 2.914c0-.69.56-1.25 1.25-1.25h4.167c.69 0 1.25.56 1.25 1.25v.833c0 .69-.56 1.25-1.25 1.25H7.914c-.69 0-1.25-.56-1.25-1.25v-.833z"
      />
    </svg>
  );
}
